module.exports = __webpack_public_path__ + "img/Logo NCI 3.becf943b.png";